import React from "react";
import {  FaGraduationCap,
  FaUserGraduate,
  FaBriefcase,
  FaPlane,
  FaStethoscope,
  FaBusinessTime,
  FaGlobeAmericas,
  FaSuitcaseRolling,
  FaGlobe,
  FaFlagUsa } from "react-icons/fa";
import "./Programs.css"; // We'll create this for custom styles

const Programs = () => {
  const programs = [
  {
    icon: <FaUserGraduate />,
    title: "Study Abroad Master's Programs",
    text: "Get expert support for pursuing your master’s degree overseas — from choosing the right University to securing scholarships and visas.",
    link: "Connect With Us",
    linkUrl: "/Contact",
  },
  {
    icon: <FaBriefcase />,
    title: "Study Foreign MBA Programs",
    text: "Boost your career with an MBA from a top global business school. We’ll guide you through applications, essays, and interview prep.",
    link: "Connect With Us",
    linkUrl: "/Contact",
  },
  {
    icon: <FaPlane />,
    title: "Travel Abroad Programs",
    text: "Join cultural exchange programs, internships, and volunteer opportunities abroad for personal and professional growth.",
   link: "Connect With Us",
    linkUrl: "/Contact",
  },
  {
    icon: <FaStethoscope />,
    title: "Study Medicine Abroad",
    text: "Pursue medical education in world-class institutions overseas with guidance on admissions, licensing, and residency requirements.",
    link: "Connect With Us",
    linkUrl: "/Contact",
  },
  {
    icon: <FaBusinessTime />,
    title: "MS Abroad",
    text: "Advance your business career with an MS from a globally recognized institution, backed by our complete admissions support.",
    link: "Connect With Us",
    linkUrl: "/Contact",
  },
];

  return (
    <section className="programs-section">
      <div className="container-fluid text-center">
        <h2 className="section-titlee">Diverse Programs & Career Opportunities Abroad
</h2>
        <p className="section-subtitlee">
          We provide extensive academic guidance for UG and PG programs, including MS, MBA, MBBS and Nursing courses
          through our unparalleled 'ground and cloud' system.
        </p>

        <div className="row program-row">
          {programs.map((prog, index) => (
            <div key={index} className="col-md-3 col-sm-12 program-card">
              <div className="icon">{prog.icon}</div>
              <h5>{prog.title}</h5>
              <p>{prog.text}</p>
              <a href={prog.linkUrl}>{prog.link}</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Programs;
